const EMPTY_DATA_MANAGER_DIAGNOSTICS_SNAPSHOT = Object.freeze({
  inFlightCount: 0,
  inFlightKeys: Object.freeze([]),
  lastLoadedAt: null,
  loadedSectionCount: 0,
  loadedSections: Object.freeze([]),
  mutationCounters: Object.freeze({
    failed: 0,
    started: 0,
    succeeded: 0,
  }),
  sectionCardinality: Object.freeze({}),
  status: "idle",
});

let dataManagerDiagnosticsSnapshot = EMPTY_DATA_MANAGER_DIAGNOSTICS_SNAPSHOT;

function cloneDataManagerDiagnosticsSnapshot(snapshot = dataManagerDiagnosticsSnapshot) {
  return {
    ...snapshot,
    inFlightKeys: [...(Array.isArray(snapshot?.inFlightKeys) ? snapshot.inFlightKeys : [])],
    loadedSections: [...(Array.isArray(snapshot?.loadedSections) ? snapshot.loadedSections : [])],
    mutationCounters: {
      failed: Number(snapshot?.mutationCounters?.failed || 0),
      started: Number(snapshot?.mutationCounters?.started || 0),
      succeeded: Number(snapshot?.mutationCounters?.succeeded || 0),
    },
    sectionCardinality: { ...(snapshot?.sectionCardinality || {}) },
  };
}

function publishDataManagerDiagnosticsSnapshot(nextSnapshot) {
  dataManagerDiagnosticsSnapshot = Object.freeze({
    ...nextSnapshot,
    inFlightKeys: Object.freeze([...(Array.isArray(nextSnapshot?.inFlightKeys) ? nextSnapshot.inFlightKeys : [])]),
    loadedSections: Object.freeze([...(Array.isArray(nextSnapshot?.loadedSections) ? nextSnapshot.loadedSections : [])]),
    mutationCounters: Object.freeze({
      failed: Number(nextSnapshot?.mutationCounters?.failed || 0),
      started: Number(nextSnapshot?.mutationCounters?.started || 0),
      succeeded: Number(nextSnapshot?.mutationCounters?.succeeded || 0),
    }),
    sectionCardinality: Object.freeze({ ...(nextSnapshot?.sectionCardinality || {}) }),
  });
}

export function getDataManagerDiagnosticsSnapshot() {
  return cloneDataManagerDiagnosticsSnapshot();
}

export function resetDataManagerDiagnosticsSnapshotForTests() {
  publishDataManagerDiagnosticsSnapshot(EMPTY_DATA_MANAGER_DIAGNOSTICS_SNAPSHOT);
}

export function updateDataManagerDiagnosticsSnapshot(nextPatch) {
  publishDataManagerDiagnosticsSnapshot({
    ...cloneDataManagerDiagnosticsSnapshot(),
    ...nextPatch,
  });
}